import dayjs from "dayjs"
import { OrganizationType } from "./models"
import { useState, useEffect } from "react"

export const isEvenNumber = (number: number) => {
  return number % 2 === 0
}

export const getPercentage = (value: number, totalValue: number) => {
  return Math.round((value / totalValue) * 100)
}

export const mbGbDisplay = (mb: number) => {
  if (mb / 1000 > 1) {
    const gb = Math.round((mb / 1000) * 10) / 10
    return `${gb} GB`
  } else {
    return `${Math.round(mb * 10) / 10} MB`
  }
}

const emailExpression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
export const checkEmailValid = (email: string) => {
  return emailExpression.test(email)
}

export const getAllOrgIds = (organizations: Array<OrganizationType>) => {
  const ids: Array<number> = organizations.map((org: OrganizationType) => parseFloat(org.id))
  return ids
}

export const checkDateIsBetween = (date: any, fromDate: any, toDate: any) => {
  const between = dayjs(date).isBetween(dayjs(fromDate), dayjs(toDate))
  return between
}

export const chunks = <T>(arr: T[], size: number): T[][] =>
  arr.reduce(
    (acc, item) => (acc.at(-1)?.length! < size ? [...acc.slice(0, -1), [...acc.at(-1)!, item]] : [...acc, [item]]),
    [[] as T[]],
  )

export const getDateIn3BusinessDays = (days: number = 3): string => {
  let date = dayjs()
  while (days > 0) {
    date = date.add(1, "day")
    if (date.day() !== 0 && date.day() !== 6) {
      days--
    }
  }
  return date.format("YYYY-MM-DD")
}

export function useInView(ref: React.RefObject<HTMLDivElement>) {
  const [isInView, setIsInView] = useState(false)

  useEffect(() => {
    if (ref.current) {
      const current = ref.current
      const observer = new IntersectionObserver(([entry]) => setIsInView(entry.isIntersecting), {
        // The intersection will be triggered only when the bottom edge of the target element
        // has passed 80% of the viewport from the bottom
        rootMargin: "0px 0px -80% 0px",
      })

      observer.observe(current)

      return () => {
        observer.unobserve(current)
      }
    }
  }, [ref, ref.current])

  return isInView
}

export function useScrollToRef(OFFSET: number) {
  const scrollToRef = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      const elementPosition = ref.current.getBoundingClientRect().top + window.pageYOffset
      const offsetPosition = elementPosition - OFFSET
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      })
    }
  }
  return scrollToRef
}
